import { z } from "zod";
import {
  vehicleTypeSchema,
  vehicleStatusSchema,
  vehicleConnectionStatusSchema,
  telemetryDataProviderSchema,
} from "../_shared";

export const vehicleListItemSchema = z.object({
  uuid: z.uuid(),
  registrationNumber: z.string().nullable(),
  reference: z.string().nullable(),
  identifier: z.string().nullable(),
  model: z.string().nullable(),
  deliveryDate: z.iso.datetime().nullable(),
  providerId: z.string().nullable(),
  updatedAt: z.iso.datetime(),
  createdAt: z.iso.datetime(),
  deactivatedAt: z.iso.datetime().nullable(),
  vehicleType: vehicleTypeSchema,
  status: vehicleStatusSchema,
  company: z.uuid(),
  rule: z.uuid().nullable(),
  driverUuid: z.uuid().nullable(),
  driverName: z.string().nullable(),
  driverPhone: z.string().nullable(),
  critAir: z.number().nullable(),
  energyClass: z.string().nullable(),
  brand: z.string().nullable(),
  energy: z.string().nullable(),
  additionalCostPerKm: z.number().nullable(),
  contractStartDate: z.iso.datetime().nullable(),
  contractEndDate: z.iso.datetime().nullable(),
  hasAnalyticsActivatedAt: z.iso.datetime().nullable(),
  latestMileage: z.number().nullable(),
  contractMileage: z.number().nullable(),
  latestMileageDate: z.iso.datetime().nullable(),
  averagePricePerLiter: z.number().nullable(),
  averageConsumption: z.number().nullable(),
  averageCarbonEmissionPerKm: z.number().nullable(),
  analyticCode: z.string().nullable(),
  noteTaking: z.string().nullable(),
  lastLatitude: z.number().nullable(),
  lastLongitude: z.number().nullable(),
  lastPositionDate: z.iso.datetime().nullable(),
  dateMec: z.iso.datetime().nullable(),
  department: z.uuid().nullable(),
  mileageOfAPeriod: z.number().nullable(),
  deviceLastActivityDate: z.iso.datetime().nullable(),
  connectionStatus: vehicleConnectionStatusSchema.nullable(),
  dataProvider: telemetryDataProviderSchema.nullable(),
  isEligible: z.boolean().nullable(),
});

export type VehicleListItem = z.infer<typeof vehicleListItemSchema>;

export const getVehiclesListResponseSchema = z.array(vehicleListItemSchema);

export type GetVehiclesListResponse = z.infer<
  typeof getVehiclesListResponseSchema
>;
